import type { ReactNode } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { GlowingBackgroundContainer } from "@/components/effects/GlowingBackgroundContainer";
import { ROUTES } from "@/constants/routes";

import { StepLeftBlock } from "./StepLeftBlock";
import { StepRightBlock } from "./StepRightBlock";

export interface ShortHelpStep {
  title: string | ReactNode;
  subtitle: string;
  showGuide?: boolean;
  imageContent: ReactNode;
  additionalInfo?: ReactNode;
}

interface ShortHelpSplitWindowProps {
  steps: ShortHelpStep[];
  onOpenOkx?: () => void;
}

export const ShortHelpSplitWindow = ({ steps, onOpenOkx }: ShortHelpSplitWindowProps) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const total = steps.length;
  const lastIndex = total - 1;

  const goToProfile = () => {
    navigate(ROUTES.profile);
  };

  const handleNext = () => {
    if (currentIndex === lastIndex) {
      goToProfile();
    } else {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (currentIndex === 0) {
      goToProfile();
    } else {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  const currentStep = steps[currentIndex];

  return (
    <div className="flex h-dvh w-full flex-col gap-4 bg-neutral-950 p-4 md:flex-row sm:p-5">
      {/* Правая часть: StepRightBlock */}
      <div 
        className="
          order-1 min-w-0 h-[clamp(145px,20vh,185px)] 
          md:order-2 md:flex md:flex-1 md:h-full md:self-stretch md:max-h-none
        "
      >
        <GlowingBackgroundContainer>
          <StepRightBlock>{currentStep.imageContent}</StepRightBlock>
        </GlowingBackgroundContainer>
      </div>

      {/* Левая часть: StepLeftBlock */}
      <div className="order-2 rounded-mds flex flex-1 min-h-0 flex-col sm:border-2 sm:border-neutral-900 sm:pt-6 md:order-1">
        <StepLeftBlock
          index={currentIndex}
          total={total}
          title={currentStep.title}
          subtitle={currentStep.subtitle}
          showGuide={currentStep.showGuide}
          additionalInfo={currentStep.additionalInfo}
          onNext={handleNext}
          onBack={handleBack}
          onOpenOkx={onOpenOkx}
        />
      </div>
    </div>
  );
};
